"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResizeObserver = exports.default = void 0;
var _react = require("react");
const useResizeObserver = ({
  disconnect,
  onResize,
  getResizeElement,
  targetRef,
  skipStateUpdate = false,
  observedDimension
} = {}) => {
  const resizeObserverRef = (0, _react.useRef)(null);
  const observedElementRef = (0, _react.useRef)(null);
  const dimensionsRef = (0, _react.useRef)({
    width: undefined,
    height: undefined
  });
  const [dimensions, setDimensions] = (0, _react.useState)({
    width: undefined,
    height: undefined
  });
  const disconnectObserver = () => {
    var _a, _b;
    observedElementRef.current = null;
    (_b = (_a = resizeObserverRef.current) === null || _a === void 0 ? void 0 : _a.disconnect) === null || _b === void 0 ? void 0 : _b.call(_a);
  };
  const handleResize = resizedElements => {
    const targetNode = resizedElements === null || resizedElements === void 0 ? void 0 : resizedElements[0];
    const targetElement = targetNode === null || targetNode === void 0 ? void 0 : targetNode.target;
    const newWidth = targetElement === null || targetElement === void 0 ? void 0 : targetElement.offsetWidth;
    const newHeight = targetElement === null || targetElement === void 0 ? void 0 : targetElement.offsetHeight;
    const widthChanged = (!observedDimension || observedDimension === 'width') && newWidth !== dimensionsRef.current.width;
    const heightChanged = (!observedDimension || observedDimension === 'height') && newHeight !== dimensionsRef.current.height;
    if (widthChanged || heightChanged) {
      const newDimensions = Object.assign(Object.assign({}, dimensions), {
        width: newWidth,
        height: newHeight
      });
      if (!skipStateUpdate) {
        setDimensions(newDimensions);
      }
      dimensionsRef.current = newDimensions;
      onResize === null || onResize === void 0 ? void 0 : onResize(newDimensions);
    }
  };
  const observeNewElement = element => {
    var _a, _b;
    if (observedElementRef.current === element) {
      return;
    }
    disconnectObserver();
    observedElementRef.current = element !== null && element !== void 0 ? element : null;
    if (element) {
      if (!resizeObserverRef.current) {
        resizeObserverRef.current = new ResizeObserver(handleResize);
      }
      (_b = (_a = resizeObserverRef.current).observe) === null || _b === void 0 ? void 0 : _b.call(_a, element);
    }
  };
  (0, _react.useEffect)(() => {
    if (disconnect) {
      disconnectObserver();
    } else if (targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) {
      observeNewElement((getResizeElement === null || getResizeElement === void 0 ? void 0 : getResizeElement(targetRef.current)) || targetRef.current);
    }
    return () => {
      disconnectObserver();
    };
  }, [disconnect]);
  return Object.assign(Object.assign({}, dimensions), {
    observeNewElement,
    disconnectObserver,
    observedElement: observedElementRef.current
  });
};
exports.useResizeObserver = useResizeObserver;
var _default = exports.default = useResizeObserver;